export default __webpack_public_path__ + "static/media/checkIcon.d18bf1f0.svg";